// This component creates a single bouncing-ball instance, without a label. It's intended to introduce the animation before we do the comparisons.
import * as React from 'react';
import { styled } from '@linaria/react';
import { Play, Pause } from 'lucide-react';

import Demo from '@/components/Demo';
import PrimaryButton from '@/components/ButtonPlayful/ButtonPrimary';
import Spinner from '@/components/Spinner';

import {
  BALL_CONTAINER_SIZE,
  BOUNCE_MAGNITUDE,
} from './CssVsJs.helpers';
import BallKeyframe from './BallKeyframe';
import BallRaf from './BallRaf';
import BallMotion from './BallMotion';
import BallGsap from './BallGsap';

interface Props {}

function CssVsJsStandalone() {
  const outerWrapperRef = React.useRef<HTMLDivElement>(null);

  const [isPlaying, setIsPlaying] = React.useState(false);

  return (
    <OuterWrapper ref={outerWrapperRef}>
      <Demo
        initialValues={{}}
        outputWrapper={null}
        customGrid={{
          gridTemplateColumns: '1fr',
          justifyItems: 'center',
        }}
        controls={[
          <Button
            key="play-pause-btn"
            onClick={() => setIsPlaying((prev) => !prev)}
            Icon={isPlaying ? Pause : Play}
          >
            {isPlaying ? 'Pause' : 'Play'}
          </Button>,
        ]}
        controlPosition="bottom"
      >
        {() => (
          <Wrapper>
            <BallWrapper>
              <BallKeyframe
                isPlaying={isPlaying}
                style={{
                  width: 48,
                  height: 48,
                  '--bounce-magnitude': BOUNCE_MAGNITUDE * 1.5 + 'px',
                }}
              />
            </BallWrapper>
          </Wrapper>
        )}
      </Demo>
    </OuterWrapper>
  );
}

const OuterWrapper = styled.div`
  position: relative;
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  width: fit-content;
  margin-inline: auto;
`;

const BallWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: ${BALL_CONTAINER_SIZE * 1.5}px;
  padding: 3px;
  box-sizing: content-box;
  border: 3px solid var(--wham-primary-300);
  border-radius: 1000px;

  &[data-is-busy='true'] {
    opacity: 0.5;
  }
`;

const Button = styled(PrimaryButton)`
  width: 100%;
  max-width: 20rem;
`;

export default CssVsJsStandalone;
